<template>
  <div class="dbs_pr-product-list__rating" v-if="hasRatings()">
    <div>
      <Rating :rating="rating"/>
      <div class="dbs_pr-product-list__ratings_count">({{ count }})</div>
    </div>
  </div>
</template>
<script>
import Rating from '@/components/Rating'

export default {
  props: ['rating', 'count'],

  components: {
    Rating
  },

  methods: {
    hasRatings () {
      return this.count > 0
    }
  }
}
</script>
<style lang="scss">
  div.dbs_pr-product-list__rating {
    margin: 5px 0 10px;
  }

  div.grid_view .dbs_pr-product-list__rating {
    text-align: left;
    height: 19px;
  }

  .dbs_pr-product-list__ratings_count {
    display: inline-block;
    padding: 0 0 3px 0;
    font-size: 12px;
    color: #bebebd;
    vertical-align: top;
  }
</style>



// WEBPACK FOOTER //
// src/components/RatingWithCounter.vue